// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__-ZCSD","amount":"Amount_amount__2iEN6","tip":"Amount_tip__7fadS","tipHeader":"Amount_tipHeader__lpblD","tipsWrap":"Amount_tipsWrap__1WD0x"};